// extracted by mini-css-extract-plugin
module.exports = {"outer":"AnimatedText_outer__35vQ-","inner":"AnimatedText_inner__169Q2","visible":"AnimatedText_visible__2Y_jU","fw":"AnimatedText_fw__25_tg"};